export default {
  header: {
    back: 'trở về',
    title: 'thay đổi mật khẩu'
  },
  label: {
    resetPay: 'thay đổi  mật khẩu thanh toán',
    resetPass: 'thay đổi  mật khẩu đăng nhập',
    oldPasswd: 'mật khẩu cũ',
    newPasswd: 'mật khẩu mới',
    reNewPasswd: 'xác nhận mật khẩu mới',
    bindgoogle: 'trình xác thực google'
  },
  placeholder: {
    oldPasswd: 'nhập mật khẩu cũ',
    newPasswd: 'nhập mật khẩu mới',
    reNewPasswd: 'xác nhận mật khẩu mới',
    bindgoogle: 'trình xác thực google'
  },
  rules: {
    oldPasswd: {
      required: 'mật khẩu cũ không được bỏ trống！',
      format: 'định dạng mật khẩu không đúng！'
    },
    newPasswd: {
      required: 'mật khẩu mới không được bỏ trống！',
      format: 'Định dạng mật khẩu không đúng! Mật khẩu phải chứa các chữ cái viết hoa, viết thường, số và ký tự đặc biệt (!@#$%^&*_), và dài từ 6 đến 25 ký tự, ví dụ: Abc123!@',
      format1:'Vui lòng nhập đúng mật khẩu gồm số + chữ hoa, chữ thường từ 8-20 ký tự, ví dụ: 123456Abcd' ,
    },
    reNewPasswd: {
      required: 'xác nhận mật khẩu mới không được bỏ trống！',
      format: 'ddijnhdajng mật khẩu không đúng！',
      same: 'mật khẩu mới và xác nhận mật khẩu không khớp',
      format1:'Vui lòng nhập đúng mật khẩu gồm số + chữ hoa, chữ thường từ 8-20 ký tự, ví dụ: 123456Abcd' ,
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/passwd.js